import { Box, Button, styled } from "@mui/material";

const BoxContainer = styled(Box)(({ theme }) => ({
  backgroundColor: "white",
  padding: theme.spacing(2),
  minHeight: "100vh",
}));

const BoxHeader = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

const FilterButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export { BoxContainer, BoxHeader, FilterButton };
